export default __webpack_public_path__ + "static/media/Group 426.fdf69e22.png";